import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../i18n';
import styles from '../../../assets/stylesheets/CallsheetInlineStyles';

class CallsheetSpecialProjectRow extends Component {
  render() {
    const { specialProject } = this.props;
    if (specialProject) {
      return (
        <>
          <tr>
            <th colSpan="4" style={styles.tableCell}>
              {`${i18n.t('location:specialProject')}: ${
                specialProject.name
              }`}
            </th>
          </tr>
          <tr>
            <td colSpan="4" style={styles.tableCell}>
              {specialProject.notes || i18n.t('callsheet:noAdditionalInfo')}
            </td>
          </tr>
        </>
      )
    }
    return null;
  }
}

CallsheetSpecialProjectRow.propTypes = {
  specialProject: PropTypes.shape({
    name: PropTypes.string.isRequired,
    notes: PropTypes.string.isRequired
  }),
}

CallsheetSpecialProjectRow.defaultProps = {
  specialProject: null,
}

export default CallsheetSpecialProjectRow;
